import { render, staticRenderFns } from "./ConfigAdd.vue?vue&type=template&id=a5969456&"
import script from "./ConfigAdd.vue?vue&type=script&lang=js&"
export * from "./ConfigAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports